<template>
  <button
    id="dropdown-input-value"
    class="dropdown-input-value__button"
    data-testid="dropdown-input-value"
    @click="handleClick"
    @keydown.enter="handleClick"
  >
    <div class="dropdown-input-value__inner">
      <BaseIcon aria-hidden="true" icon="ic_search" />
      <BaseText size="lg" :color="NebraskaColors.textPrimary">
        {{ inputValue }}
      </BaseText>
    </div>
  </button>
</template>

<script lang="ts">
import { Component, Vue, Prop } from 'vue-property-decorator';

import { BaseText, BaseIcon } from '@warrenbrasil/nebraska-web';

import { NebraskaColors } from '@warrenbrasil/nebraska-tokens-web';

@Component({
  components: {
    BaseIcon,
    BaseText
  }
})
export default class DropdownInputValueItem extends Vue {
  @Prop({ type: String, required: true })
  private inputValue!: string;

  private NebraskaColors = NebraskaColors;

  private handleClick() {
    this.$emit('input-value-click', this.inputValue);
  }
}
</script>

<style lang="less" scoped>
.dropdown-input-value {
  &__button {
    background: @background-secondary;
    padding: 0px @size-spacing-x300;
    width: 100%;
    border-radius: 8px;

    &:hover,
    &:focus {
      background: @background-hover;
      outline: none;
    }
  }

  &__inner {
    display: flex;
    align-items: center;
    padding: @size-spacing-x350 0px;
    width: 100%;

    p {
      margin-left: @size-spacing-x400;
      font-weight: bold;
    }
  }
}
</style>
